const EXPO_DIRECTORY_PATH_RE = /^\/(?:global-events-exhibitions|expos)\/([^/?#]+)/;

export function expoSlugFromDiscoverReturnTo(returnTo?: string | null): string | null {
  if (!returnTo?.trim()) return null;
  const path = returnTo.trim().split("?")[0] || "";
  const match = EXPO_DIRECTORY_PATH_RE.exec(path);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function resolveExpoGuestSlug(args: {
  fromExpoQuery?: string | null;
  discoverReturnTo?: string | null;
}): string | null {
  const fromQuery = args.fromExpoQuery?.trim();
  if (fromQuery) return fromQuery;
  return expoSlugFromDiscoverReturnTo(args.discoverReturnTo);
}

export function expoCompanyProfileSearch(expoSlug: string): string {
  return `?fromExpo=${encodeURIComponent(expoSlug)}`;
}

/** Header CTA on expo exhibitor company profiles (opens ExpoCompanyReachoutModal). */
export const EXPO_COMPANY_REACH_OUT_CTA = "Reach-out";

/** Logged-in expo visitor company profile (not collaboration workspace). */
export function buildExpoVisitorCompanyProfilePath(companyId: string, search = ""): string {
  return `/expos/company/${companyId}${search}`;
}

export function expoSlugFromProfileSearch(search?: string | null): string | null {
  if (!search?.trim()) return null;
  const qs = search.trim().startsWith("?") ? search.trim().slice(1) : search.trim();
  return new URLSearchParams(qs).get("fromExpo")?.trim() || null;
}
